function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { InternalConfigProvider } from '../../config/internal-config-provider';
import { isRemoteConfigEnabled } from '../../config/core-video-config/core-video-config-types';
import { DvrWindowDuration, StreamVendor } from '../../core/player/playout-data';
var REMOTE_CONFIG_ENABLED_OVERRIDE = false;
// will be removed when extended window fully onboarded to remote config
export var ExtendedWindowManager = /*#__PURE__*/ function() {
    "use strict";
    function ExtendedWindowManager() {
        _class_call_check(this, ExtendedWindowManager);
    }
    _create_class(ExtendedWindowManager, null, [
        {
            key: "getExtendedWindowConfig",
            value: function getExtendedWindowConfig(playbackType, preferredWindowDuration, playerCapabilities, internalConfigPerPlaybackType) {
                var internalConfig = InternalConfigProvider.getForPlaybackType(internalConfigPerPlaybackType, playbackType);
                if (isRemoteConfigEnabled(internalConfig) && REMOTE_CONFIG_ENABLED_OVERRIDE) {
                    return ExtendedWindowManager.getFromRemoteConfig(internalConfig, playerCapabilities);
                }
                return ExtendedWindowManager.getFromClientPreferredWindow(preferredWindowDuration, internalConfig.allowedDvrWindowDurations, playerCapabilities);
            }
        },
        {
            key: "getBestAvailableDuration",
            value: function getBestAvailableDuration() {
                var allowedDvrWindows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], playerCapabilities = arguments.length > 1 ? arguments[1] : void 0;
                var containsFullEvent = allowedDvrWindows.includes(DvrWindowDuration.FullEvent);
                var containsExtended = allowedDvrWindows.includes(DvrWindowDuration.Extended);
                if (containsFullEvent && playerCapabilities.supportsFullEvent) {
                    return DvrWindowDuration.FullEvent;
                } else if (containsExtended) {
                    return DvrWindowDuration.Extended;
                }
                return DvrWindowDuration.Restricted;
            }
        },
        {
            key: "getFromRemoteConfig",
            value: function getFromRemoteConfig(internalConfig, playerCapabilities) {
                var _obj;
                var defaultConfiguration = (_obj = {}, _define_property(_obj, StreamVendor.Harmonic, DvrWindowDuration.Restricted), _define_property(_obj, StreamVendor.IStreamPlanet, DvrWindowDuration.Restricted), _define_property(_obj, StreamVendor.Unknown, DvrWindowDuration.Restricted), _obj);
                var preferredConfig = _object_spread({}, defaultConfiguration);
                var coreVideoConfig = internalConfig.allowedDvrWindowDurations || {};
                Object.keys(coreVideoConfig).forEach(function(key) {
                    var vendor = key;
                    var bestAvailable = ExtendedWindowManager.getBestAvailableDuration(coreVideoConfig[vendor], playerCapabilities);
                    preferredConfig[vendor] = bestAvailable;
                });
                return preferredConfig;
            }
        },
        {
            key: "getFromClientPreferredWindow",
            value: function getFromClientPreferredWindow(preferredWindowDuration) {
                var allowedDvrWindowDurations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, playerCapabilities = arguments.length > 2 ? arguments[2] : void 0;
                function getWindowForVendor(vendor) {
                    var _allowedDvrWindowDurations_vendor, _allowedDvrWindowDurations_vendor1, _allowedDvrWindowDurations_vendor2;
                    var isPreferredWindowAllowed = preferredWindowDuration === DvrWindowDuration.Restricted || ((_allowedDvrWindowDurations_vendor = allowedDvrWindowDurations[vendor]) === null || _allowedDvrWindowDurations_vendor === void 0 ? void 0 : _allowedDvrWindowDurations_vendor.includes(preferredWindowDuration));
                    var isExtendedAllowed = (_allowedDvrWindowDurations_vendor1 = allowedDvrWindowDurations[vendor]) === null || _allowedDvrWindowDurations_vendor1 === void 0 ? void 0 : _allowedDvrWindowDurations_vendor1.includes(DvrWindowDuration.Extended);
                    var isFullEventSupported = playerCapabilities.supportsFullEvent;
                    var isFullEventAllowed = isFullEventSupported && ((_allowedDvrWindowDurations_vendor2 = allowedDvrWindowDurations[vendor]) === null || _allowedDvrWindowDurations_vendor2 === void 0 ? void 0 : _allowedDvrWindowDurations_vendor2.includes(DvrWindowDuration.FullEvent));
                    switch(preferredWindowDuration){
                        case DvrWindowDuration.FullEvent:
                            if (isPreferredWindowAllowed && isFullEventSupported) {
                                return DvrWindowDuration.FullEvent;
                            }
                            if (isExtendedAllowed) {
                                return DvrWindowDuration.Extended;
                            }
                            return DvrWindowDuration.Restricted;
                        case DvrWindowDuration.Extended:
                            if (isPreferredWindowAllowed) {
                                return DvrWindowDuration.Extended;
                            }
                            if (isFullEventAllowed) {
                                return DvrWindowDuration.FullEvent;
                            }
                            return DvrWindowDuration.Restricted;
                        default:
                            return DvrWindowDuration.Restricted;
                    }
                }
                var _obj;
                var configuration = (_obj = {}, _define_property(_obj, StreamVendor.Harmonic, getWindowForVendor(StreamVendor.Harmonic)), _define_property(_obj, StreamVendor.IStreamPlanet, getWindowForVendor(StreamVendor.IStreamPlanet)), _define_property(_obj, StreamVendor.Unknown, getWindowForVendor(StreamVendor.Unknown)), _obj);
                return configuration;
            }
        }
    ]);
    return ExtendedWindowManager;
}();

//# sourceMappingURL=extended-window-manager.js.map